import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  {
    text: 'No',
    align: 'start',
    value: 'number_index',
    width: '10',
  },
  {
    text: 'MID',
    value: 'merchantId',
  },
  {
    text: 'Nama Merchant',
    value: 'merchantName',
  },
  {
    text: 'Email',
    value: 'userEmail',
  },
  {
    text: 'Role User',
    value: 'userRole',
  },
  {
    text: 'Force Change Password',
    value: 'forceChangePassword',
  },
  {
    text: 'Created At',
    value: 'createdAt',
  },
  {
    text: 'First Login',
    value: 'firstLogin',
  },
  {
    text: 'Last Login',
    value: 'lastLogin',
  },
  {
    text: 'Count Of Login',
    value: 'countLogin',
    align: 'center',
    textAlign: 'text-center',
  },
  { 
    text: 'Action', 
    value: 'action',  
    width: '100' 
  },
]);
export const search = {
  createdDate: [],
  merchantId: '',
  userRole: '',
};
